/*!
  Elysian, by Koding Themes
  sticky-menu.js
  https://kodingthemes.com
*/

document.addEventListener("DOMContentLoaded", function (e) {
  var elem = document.querySelector("#product-info");
  var stickyFormContainer = document.querySelector(".sticky-form-container");
  if (elem != null && stickyFormContainer != null) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: "body",
        start: "top+=18% top+=10%",
        end: "bottom-=2% bottom",
        markers: false,
        scrub: 1,
        onEnter: () => {
          stickyFormContainer.classList.add("sticky-form");
        },
        onEnterBack: () => {
          stickyFormContainer.classList.add("sticky-form");
        },
        onLeave: () => {
          stickyFormContainer.classList.remove("sticky-form");
        },
        onLeaveBack: () => {
          stickyFormContainer.classList.remove("sticky-form");
        },
      },
    });
    console.log("sticky menu");
  }
});
